import { useSnackbar } from "notistack";
import useFingerPrintCaptureForm from "../../../hooks/useFingerPrintForm";
import DeviceAlert from "../../../components/Fingerprint/DeviceAlert";
import FullLoader from "../../../components/Loader/FullLoader.component";
import { FingerprintForm } from "./FingerprintForm";
import { FingerprintForm_FNA_INT } from "./FingerprintForm_FNA_INT";

interface FingerprintFormProps {
  token: string;
  handleChangeTab: Function;
  roleLogged: "FNA" | "INT" | "ESTANDAR" | "DEMAND" | "NRM";
  haveGeolocatization: boolean;
}

const FingerprintFormMain = ({
  handleChangeTab,
  roleLogged,
  haveGeolocatization,
}: FingerprintFormProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const {
    submitForm,
    handleProcessType,
    processTypeState,
    handleNumberParticipants,
    numberParticipantsLocal,
    submitState,
    primaryParticipant,
    hideModalATDP,
    setDeviceAlert,
    handleValidate,
    handleDataSaveForm,
    isOpenModalATPD,
    loadingFingerPrint,
    deviceAlert,
    handleStatesToFalse,
    isValidDevice,
    connnectDevice,
    isLoading,
  } = useFingerPrintCaptureForm({
    enqueueSnackbar,
    roleLogged,
  });

  return (
    <>
      {roleLogged === "FNA" || roleLogged === "INT" || roleLogged === "DEMAND" ? (
        <>
          <FingerprintForm_FNA_INT
            formSubmit={submitForm}
            handleValidate={handleValidate}
            handleStatesToFalse={handleStatesToFalse}
            hideModalATDP={hideModalATDP}
            connnectDevice={connnectDevice}
            isValidDevice={isValidDevice}
            haveGeolocatization={haveGeolocatization}
            handleChangeTab={handleChangeTab}
            roleLogged={roleLogged}
            isOpenModalATPD={isOpenModalATPD}
            isLoading={isLoading}
          />
        </>
      ) : (
        <>
          <FingerprintForm
            handleValidate={handleValidate}
            formSubmit={submitForm}
            handleDataSaveForm={handleDataSaveForm}
            handleProcessType={handleProcessType}
            handleNumberParticipants={handleNumberParticipants}
            hideModalATDP={hideModalATDP}
            handleStatesToFalse={handleStatesToFalse}
            connnectDevice={connnectDevice}
            processTypeState={processTypeState}
            numberParticipantsLocal={numberParticipantsLocal}
            submitState={submitState}
            primaryParticipant={primaryParticipant}
            isOpenModalATPD={isOpenModalATPD}
            handleChangeTab={handleChangeTab}
            isValidDevice={isValidDevice}
            isLoading={isLoading}
          />
        </>
      )}
      <DeviceAlert
        isOpen={deviceAlert}
        isClose={() => {
          setDeviceAlert(false);
        }}
      />
      <FullLoader open={loadingFingerPrint} />
    </>
  );
};
export { FingerprintFormMain };
